import * as yup from 'yup'

import { INewPartnerStep3 } from 'features/Partners/types'

export const contactUrbvanSchema = (): yup.SchemaOf<INewPartnerStep3['kam']> => {
  return yup.object().shape({
    id: yup.string().optional(),
    username: yup.string().optional(),
    firstName: yup.string().optional(),
    lastName: yup.string().optional()
  })
}
